module.exports = __webpack_public_path__ + "static/media/individual1.9632611b.jpg";